export const getCardStyle = (darkMode) => ({
  backgroundColor: darkMode ? "#222" : "#fffffffc",
  border: `1px solid ${darkMode ? "#333" : "#e0e0e0"}`,
  borderRadius: "8px",
  boxShadow: darkMode
    ? "0 2px 8px rgba(0,0,0,0.3)"
    : "0 2px 8px rgba(0,0,0,0.05)",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  padding: 0,
});
